import 'swiper/css';
import React from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
function MarqueeClassic({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  // const animationItems = item?.data?.customizationTypes?.animationDuration?.split("|")
  // const animationSpeed =   isNaN(Number(item?.data?.customization?.animationDuration)) ? animationItems?.indexOf(item?.customization?.animationDuration) : Number(item?.customization?.animationDuration)
  return (
    <>
      {item?.data?.text?.length > 0 ? (
        <div style={{ padding: `${customization?.containerPadding}` }}>
          <div
            className="overflow-visible bg-black flex flex-row w-full"
            style={{ backgroundColor: customization?.backgroundColor }}
          >
            <div className="text-white overflow-hidden flex flex-row w-full ">
              <div
                className={` whitespace-nowrap self-center w-full flex-col justify-start`}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: customization?.textAlignment,
                  fontWeight: customization?.textWeight,
                  fontStyle: customization?.textStyle,
                  fontSize: customization?.textSize,
                  color: customization?.textColor,
                  wordSpacing: `${customization?.textWordSpacing}`,
                  letterSpacing: `${customization?.textLetterSpacing}`,
                  fontFamily: customization?.textFont,
                  height: customization?.height,
                  paddingRight: 5,
                  paddingLeft: 5,
                }}
              >
                {item?.data?.text?.split('\n')?.map((line, index) => (
                  <div key={index}>{line}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
}

export default MarqueeClassic;
